"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ERR_INVALID_PEER_SCORE_THRESHOLDS = exports.ERR_INVALID_PEER_SCORE_PARAMS = void 0;
exports.ERR_INVALID_PEER_SCORE_PARAMS = 'ERR_INVALID_PEER_SCORE_PARAMS';
exports.ERR_INVALID_PEER_SCORE_THRESHOLDS = 'ERR_INVALID_PEER_SCORE_THRESHOLDS';